import { RSAA } from 'redux-api-middleware';

export const ROLES_IS_FETCHING = 'ROLES_IS_FETCHING';
export const ROLES_GET_SUCCESS = 'ROLES_GET_SUCCESS';
export const ROLES_GET_ERROR = 'ROLES_GET_ERROR';

// Initial State
export const initialState = {
  defaultSearchParams: {
    perPage: 16,
    page: 1
  },
  isFetching: false,
  items: [],
  error: null
};

// Actions
export const getRolesList = queryString => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_ROLE',
      controlAction: 'collection',
      queryString,
      types: [
        ROLES_IS_FETCHING,
        {
          type: ROLES_GET_SUCCESS,
          meta: { ...queryString }
        },
        ROLES_GET_ERROR
      ]
    }
  };
};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case ROLES_IS_FETCHING:
      return { ...state, isFetching: true, error: null };

    case ROLES_GET_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        items: action.payload
      };

    case ROLES_GET_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };

    default:
      return state;
  }
};
